/**
 * Validator for react-hook-form URL inputs that are allowed to be empty.
 *
 * Returns `true` when the value is empty (callers control required-ness
 * separately) or when the value parses as a URL with a hostname containing
 * a dot. Otherwise returns the user-facing error message.
 *
 * The normalisation prepends `https://` if the user omitted the scheme so
 * that bare inputs like `google.com` are accepted.
 */
export const URL_VALIDATION_MESSAGE =
	"Please enter a valid URL (e.g. google.com)";

export const validateOptionalUrl = (value: string): true | string => {
	if (!value) return true;
	const normalized = /^https?:\/\//i.test(value) ? value : `https://${value}`;
	try {
		const url = new URL(normalized);
		if (!/\./.test(url.hostname)) {
			return URL_VALIDATION_MESSAGE;
		}
		return true;
	} catch {
		return URL_VALIDATION_MESSAGE;
	}
};
